import {Component, Input, OnInit} from '@angular/core';
import {faEdit} from '@fortawesome/free-solid-svg-icons/faEdit';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-button-project-edit',
  templateUrl: './button-project-edit.component.html',
  styleUrls: ['./button-project-edit.component.css']
})
export class ButtonProjectEditComponent implements OnInit {

  faEdit = faEdit;
  url: string;
  @Input() projectId;
  @Input() selectedStep;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    if (!this.projectId) {
      this.projectId = this.activatedRoute.snapshot.paramMap.get('idProject');
    }
    this.url = `/projects/${this.projectId}/${this.selectedStep}`;
  }

}
